module.exports = __webpack_public_path__ + "img/mission.77c38784.jpg";